export const CREATES_PROCUREMENT_PARAM = "opprett";
export const CREATES_PROCUREMENT_VALUE = "anskaffelse";
export const PROJECT_PARAM = "prosjekt";
export const NEED_PARAM = "behov";
export const PROCUREMENT_PARAM = "anskaffelse";
export const BASIS_PROCUREMENT_PARAM = "fra-anskaffelse";
export const BASIS_CONTRACT_PARAM = "fra-kontrakt";

export const projectOfNewProcurement = (search: string): string | undefined => {
  const query = new URLSearchParams(search);
  if (query.get(CREATES_PROCUREMENT_PARAM) !== CREATES_PROCUREMENT_VALUE) return undefined;
  return query.get(PROJECT_PARAM) || undefined;
};
